import Cookies from "js-cookie";

export const logOut = (redirectCallback, isVisible = true) => {
    // let url = window.location.href;
    if (isVisible) alert("Oturum süresi dolmuş.");

    localStorage.removeItem("user");
    localStorage.removeItem("expiratDate")
    localStorage.removeItem("fullName");
    localStorage.removeItem("employee_id");
    localStorage.removeItem("roles");
    localStorage.removeItem("warehouse");

    deleteCookies();

    Cookies.set('sessionKey', "");
    if (document.querySelector("title")) document.querySelector("title").innerHTML = "UK Lojistik";

    // Yönlendirme işlemini callback ile yapıyoruz
    // localStorage.setItem("loginRedirectUrl", url);
    if (typeof redirectCallback === "function") {
        redirectCallback();  // Yönlendirme burada yapılacak
    }
    return;
}

function deleteCookies() {
    var allCookies = document.cookie.split(';');
    for (var i = 0; i < allCookies.length; i++) {
        document.cookie = allCookies[i] + "=;expires=" + new Date(0).toUTCString();
    }

    Cookies.set('sessionKey', "");
}
